import React, { useContext } from 'react'
import { ConfigContext } from '../contexts'
import { TypeConfigContext } from '../types'

const useConfig = (): TypeConfigContext => {
    return useContext(ConfigContext)
}

export default useConfig
